import { createSlice } from "@reduxjs/toolkit";
import { ITrainingBlockSlice } from "../../../models/master/training";


const initialTrainingBlockState: ITrainingBlockSlice = {
  trainingBlocks:undefined,
  trainingBlock:undefined
};

const trainingBlockSlice = createSlice({
  name: "trainingBlock",
  initialState: initialTrainingBlockState,
  reducers: {
    setTrainigBlocks: (state, action: { payload: any }) => {
      state.trainingBlocks = action.payload;
    },
    setTrainigBlock: (state, action: { payload: any }) => {
      state.trainingBlock = action.payload;
    },
    
  },
});

export const { setTrainigBlocks, setTrainigBlock } =
trainingBlockSlice.actions;

const trainingBlockReducer = trainingBlockSlice.reducer;

export type trainingBlockState = ReturnType<typeof trainingBlockReducer>;

export default trainingBlockReducer;
